import { render } from "./AddEditTaskModal.vue?vue&type=template&id=64729e97&scoped=true"
import script from "./AddEditTaskModal.vue?vue&type=script&lang=js"
export * from "./AddEditTaskModal.vue?vue&type=script&lang=js"

import "./AddEditTaskModal.vue?vue&type=style&index=0&id=64729e97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64729e97"]])

export default __exports__